import React from "react";
import styled from "styled-components";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import UpgradeIcon from "@icons/Pro/UpgradeLightningBoltIcon.svg";

const SubscriptionBlockWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    width: 100%;
`;

const ProUpgradeIcon = styled(UpgradeIcon)`
    margin: 0 6px;
    fill: ${(props) => props.theme.iconColor};
`;

const SubscriptionLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 4px;
`;

const PRO_TIER_LABEL = "Pro Tier";
const PRO_FREE_TRIAL_LABEL = "Pro (Free Trial)";
const FREE_TIER_LABEL = "Free Tier";
const SUBSCRIPTION_TYPE_LABEL = "Subscription: ";

interface SubscriptionTierBlockProps {
    readonly isVisible: boolean;
    readonly buttonComponent?: React.ReactNode;
    readonly hideLabel?: boolean;
}
function SubscriptionTierBlock(props: SubscriptionTierBlockProps) {
    const { userData }: UserContextType = useUserContext();

    let subscriptionType = userData?.proUserInfo?.isProUser ? PRO_TIER_LABEL : FREE_TIER_LABEL;
    if (userData?.proUserInfo?.isProUser) {
        if (userData.proUserInfo.freeTrialInfo?.isFreeTrialActive) {
            subscriptionType = PRO_FREE_TRIAL_LABEL;
        } else if (userData.proUserInfo.stripeInfo) {
            subscriptionType = PRO_TIER_LABEL;
        }
    } else {
        subscriptionType = FREE_TIER_LABEL;
    }

    const subscriptionLabel = `${SUBSCRIPTION_TYPE_LABEL}${subscriptionType}`;

    return props.isVisible ? (
        <SubscriptionBlockWrapper>
            {!props.hideLabel && (
                <SubscriptionLabel>
                    <ProUpgradeIcon />
                    {subscriptionLabel}
                </SubscriptionLabel>
            )}

            {props.buttonComponent}
        </SubscriptionBlockWrapper>
    ) : null;
}

export default SubscriptionTierBlock;
